import { useContext } from "react";
import useGet from "./useGet";
import { DetailsActionContext } from "./DetailsActionContext";
import { useNavigate } from "react-router-dom";
import SuperOrderDetails from "@beeldit/ecommerce/super-orders/components/SuperOrderDetails";
import {TenantAndCommerceContext} from "@main/contexts/TenantAndCommerceContext";

function useDetailsAction(id: number): any {
  const navigate = useNavigate();

  const { tenantId, commerceId } = useContext(TenantAndCommerceContext);

  const detailsFunction = (id: any) => {
      navigate(`/panel/${tenantId}/${commerceId}/admin/order/${id}`);
  };

  const get = useGet();
  const getFunction = (id: number) => get(id);

  /** Edition element definition */
  const { element } = useContext(DetailsActionContext);

  const actionTemplate = <SuperOrderDetails context={DetailsActionContext} getFunction={getFunction}/>;

  /** END EDIT FORM ACTION */

  return {
    detailsFunction,
    getFunction,
    actionTemplate,
    element,
  };
}

export default useDetailsAction;
